import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "section"
}
const _hoisted_2 = {
  key: 2,
  class: "flex justify_center offline-section mobile-stub"
}
const _hoisted_3 = { class: "error__wrapper" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  d: "M0.431641 1L113.569 114.137M0.431641 114.137L113.569 1",
  stroke: "#8F8F8F"
}, null, -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = {
  key: 0,
  class: "error__divider"
}
const _hoisted_7 = { class: "text_centered" }
const _hoisted_8 = { class: "plain-text text_secondary text_centered" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.errorMessage && _ctx.isMobile)
      ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
          _createVNode(_component_router_view)
        ]))
      : _createCommentVNode("", true),
    (!_ctx.errorMessage && !_ctx.isMobile)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(["viewport", {'viewport_ipad' : _ctx.isIpad}])
        }, [
          _createVNode(_component_router_view)
        ], 2))
      : _createCommentVNode("", true),
    (_ctx.errorMessage)
      ? (_openBlock(), _createElementBlock("section", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (_openBlock(), _createElementBlock("svg", {
              class: _normalizeClass(["error__icon cross-icon", {'error__icon_scaled' : _ctx.isMobile && _ctx.isLandscape}]),
              width: "114",
              height: "115",
              viewBox: "0 0 114 115",
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg"
            }, _hoisted_5, 2)),
            (!_ctx.isMobile || (_ctx.isMobile && !_ctx.isLandscape))
              ? (_openBlock(), _createElementBlock("div", _hoisted_6))
              : _createCommentVNode("", true),
            _createElementVNode("h3", _hoisted_7, _toDisplayString(_ctx.errorMessage.title), 1),
            _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.errorMessage.message), 1)
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}